import { Risk, RiskSummary, RiskCategory } from "../types";

// Mock data
const MOCK_RISK_SUMMARY: RiskSummary = {
    total: 36,
    critical: 0,
    high: 28,
    medium: 7,
    low: 1,
};

const MOCK_RISKS: Risk[] = [
    {
        id: "1",
        type: "commissioning",
        severity: "high",
        projectName: "Capacity Upgrade – Signaling Modernization",
        currentPhase: "Construction (SG4)",
        budget: 9800000,
        projectId: "CDL-0172",
        description: "Planned Commissioning 30 Jul 2025 but still in Construction (SG4). 100 days overdue.",
        category: "commissioning",
    },
    {
        id: "2",
        type: "close-out",
        severity: "high",
        projectName: "Capacity Upgrade – Signaling Modernization",
        currentPhase: "Construction (SG4)",
        budget: 9800000,
        projectId: "CDL-0172",
        description: "Planned Close-out 30 Aug 2025 but still in Construction (SG4). 129 days overdue.",
        category: "close-out",
    },
    {
        id: "3",
        type: "commissioning",
        severity: "high",
        projectName: "Asset Health – Power Distribution",
        currentPhase: "Construction (SG4)",
        budget: 6700000,
        projectId: "CDL-9164",
        description: "Planned Commissioning 20 Jun 2025 but still in Construction (SG4). 200 days overdue.",
        category: "commissioning",
    },
    {
        id: "4",
        type: "close-out",
        severity: "high",
        projectName: "Asset Health – Power Distribution",
        currentPhase: "Construction (SG4)",
        budget: 6700000,
        projectId: "CDL-9164",
        description: "Planned Close-out 20 Jul 2025 but still in Construction (SG4). 170 days overdue.",
        category: "close-out",
    },
    {
        id: "5",
        type: "commissioning",
        severity: "high",
        projectName: "Asset Health – Critical Infrastructure",
        currentPhase: "Construction (SG4)",
        budget: 6300000,
        projectId: "CDL-0186",
        description: "Planned Commissioning 05 Aug 2025 but still in Construction (SG4). 151 days overdue.",
        category: "commissioning",
    },
    {
        id: "6",
        type: "close-out",
        severity: "high",
        projectName: "Asset Health – Critical Infrastructure",
        currentPhase: "Construction (SG4)",
        budget: 6300000,
        projectId: "CDL-0186",
        description: "Planned Close-out 05 Sept 2025 but still in Construction (SG4). 123 days overdue.",
        category: "close-out",
    },
];

// Mock API functions
export const getRiskSummary = async (): Promise<RiskSummary> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 400));
    return MOCK_RISK_SUMMARY;
};

export const getRisks = async (category?: RiskCategory): Promise<Risk[]> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    
    if (!category || category === "all") {
        return MOCK_RISKS;
    }
    
    return MOCK_RISKS.filter(risk => risk.category === category);
};
